module.exports = __webpack_public_path__ + "img/20190929135439613.2af05748.jpg";